<template>
  <!-- 添加一个唯一的父级类名 "custom-tabs-container" -->
  <div class="custom-tabs-container">
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick" @tab-remove="handleTabRemove">
      <el-tab-pane :closable="tab.closable" v-for="tab in activeTabs" :key="tab.path" :label="tab.name"
        :name="tab.path">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {
    mapState,
    mapMutations
  } from 'vuex';

  export default {
    name: 'Tabs',
    computed: {
      ...mapState(['activeTabs', 'activeTab'])
    },
    methods: {
      ...mapMutations(['setActiveTab', 'closeTab']),
      handleTabClick(tab) {
        // 当点击标签页时，设置当前激活的标签页并导航到对应的路由
        this.setActiveTab(tab.name);
        this.$router.push(tab.name);
      },
      handleTabRemove(tabName) {
        // 当关闭标签页时，调用关闭标签页的 mutation
        this.closeTab(tabName);
        // 获取剩余的激活标签页
        const remainingTabs = this.activeTabs.filter(tab => tab.path !== tabName);
        if (remainingTabs.length > 0) {
          // 如果还有剩余标签页，设置最后一个标签页为激活状态并导航到该路由
          const lastTab = remainingTabs[remainingTabs.length - 1];
          this.setActiveTab(lastTab.path);
          this.$router.push(lastTab.path);
        } else {
          // 如果没有剩余标签页，导航到首页（这里假设首页路径为 '/'）
          this.$router.push('/');
        }
      }
    }
  };
</script>
<style>
  .custom-tabs-container .el-tabs__item {
    box-sizing: border-box;
    height: 34px;
    margin-right: 4px;
    line-height: 34px;
    border: 1.5px solid #dcdfe6 !important;
    border-radius: 4px;
    transition: padding .3s cubic-bezier(.645, .045, .355, 1) !important;
    font-weight: 500;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }

  .el-tabs__nav {
    border: 0px !important;
  }

  .custom-tabs-container .el-tabs__item.is-active {
    /* background-color: #0187fb; */
    /* 蓝色背景 */
    /* color: white; */
    /* 白色文字 */
    border-color: #0187fb !important;
    /* 蓝色边框 */

  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Tabs.vue